
export default function NavButton({ children, highlight, onClick }) {
  var highlightClass = (highlight) ? 'nav-button-selected' : '';
  return (
    <button 
      onClick={onClick} 
      className={ `flex px-4 py-4 my-2 xl:my-0 mr-0 xl:mr-4 border cursor-pointer nav-button ${highlightClass}` }>
        {children}
    </button>
  );
}
